import { useCallback } from "react";
import { useMutation } from "@apollo/client";

import FlashContext from "components/FlashMessages/FlashContext";
import useTypedContext from "hooks/useTypedContext";
import { MutationBitbucketCloudIntegrationCreateV2Args } from "types/generated";
import useAnalytics from "hooks/useAnalytics";
import { AnalyticsPageVCS } from "hooks/useAnalytics/pages/vcs";

import { CREATE_BITBUCKET_CLOUD_INTEGRATION_V2 } from "./gql";

const useCreateBitbucketCloudIntegrationV2 = () => {
  const { onError, reportSuccess } = useTypedContext(FlashContext);

  const trackSegmentAnalyticsEvent = useAnalytics({
    page: AnalyticsPageVCS.VCSIntegrations,
  });

  const [bitbucketCloudIntegrationCreate, { loading }] = useMutation(
    CREATE_BITBUCKET_CLOUD_INTEGRATION_V2
  );

  const createBitbucketCloudIntegration = useCallback(
    (input: MutationBitbucketCloudIntegrationCreateV2Args, successCallback?: () => void) => {
      bitbucketCloudIntegrationCreate({
        variables: input,
      })
        .then(({ data }) => {
          if (data?.bitbucketCloudIntegrationCreateV2) {
            reportSuccess({
              message: `Integration ${data.bitbucketCloudIntegrationCreateV2.name} was successfully created`,
            });
            successCallback?.();

            trackSegmentAnalyticsEvent("Bitbucket Cloud - Setup Finished", {
              labels: input.input.customInput?.labels?.length,
              space: input.input.customInput?.spaceID,
            });
          }
        })
        .catch(onError);
    },
    [bitbucketCloudIntegrationCreate, onError, reportSuccess, trackSegmentAnalyticsEvent]
  );

  return {
    createBitbucketCloudIntegration,
    loading,
  };
};

export default useCreateBitbucketCloudIntegrationV2;
